/*
 * @Author: your name
 * @Date: 2020-02-19 13:52:30
 * @LastEditTime: 2020-07-17 15:20:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-mall\apis\feedback.js
 */
const feedback = {
  getConfig: {
    url: '/mall/feedback/isSupport',
    type: 'get'
  },
  // 获取登录用户信息
  getLoginUser: {
    url: '/mall/userInfo/getLoginUser',
    type: 'get'
  }
}
export default feedback
